import { Flex, Radio, StyleSystemProps, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyleCheckbox = styled(Radio)`
  & > span {
    font-weight: 600;
  }
  .joykit-choice-indicator {
    border: none;
    background-color: ${props => props.theme.colors.gray5};
    ::after {
      background-color: ${props => props.theme.colors.mono14};
    }
  }
`;

export const StyledFilterFloatingButton = styled(Flex)``;
const filterFloatingButtonStyles = (routeHasBottomBar?: boolean): StyleSystemProps => ({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  bottom: routeHasBottomBar ? pxToRem(88) : 8,
  backgroundColor: 'black',
  left: '50%',
  paddingY: 4,
  paddingX: 6,
  transform: 'translateX(-50%)',
  color: 'white',
  cursor: 'pointer',
  borderRadius: 28,
  columnGap: 3,
  height: pxToRem(56),
});

export const styles = {
  filterFloatingButton: filterFloatingButtonStyles,
};
